import { Checkbox } from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { Swiper } from "src/components";
import { SwiperSlide } from "swiper/react";
import { type Swiper as SwiperType } from "swiper/types";

import { MODAL_SLIDES } from "../constants";
import { swiperAtom, swiperIndexPage } from "../store";
import css from "../WelcomeModal.module.scss";
import { SliderCard } from "./SliderCard";
import { SliderContent } from "./SliderContent";
import { SliderDotsControls } from "./SliderDotsControls";
import { SliderPrevNextButtons } from "./SliderPrevNextButtons";

interface ModalContentProps {
  handleCloseWelcomeModal: () => void;
  isDontShow: boolean;
  setIsDontShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalContent = ({
  handleCloseWelcomeModal,
  isDontShow,
  setIsDontShow,
}: ModalContentProps) => {
  const setSwiperRef = useAction(swiperAtom);
  const [, setSwiperIndexSlide] = useAtom(swiperIndexPage);

  const handleDisableWelcomeModal = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setIsDontShow(e.target.checked);
  };

  const handleChangeSlide = (swiper: SwiperType) => {
    setSwiperIndexSlide(swiper.activeIndex);
  };

  return (
    <div className={css.modalContentContainer}>
      <div className={css.modalContentSwiperContainer}>
        <div className={css.disableWelcomeModalCheckboxContainer}>
          <Checkbox
            title="Не показывать"
            checked={isDontShow}
            onChange={handleDisableWelcomeModal}
          >
            Не показывать
          </Checkbox>
        </div>
        <Swiper
          allowTouchMove={false}
          slidesPerView={1}
          onSwiper={setSwiperRef}
          onChangeSlide={handleChangeSlide}
        >
          {MODAL_SLIDES.map((slide) => {
            return (
              <SwiperSlide key={"slide." + slide.id}>
                <SliderCard cardId={slide.id} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      <div className={css.modalControlsContainer}>
        <SliderDotsControls />

        <SliderContent />
        <SliderPrevNextButtons
          handleCloseWelcomeModal={handleCloseWelcomeModal}
        />
      </div>
    </div>
  );
};
